import { render, staticRenderFns } from "./OcrItemListAction.vue?vue&type=template&id=90eb8e86&"
import script from "./OcrItemListAction.vue?vue&type=script&lang=js&"
export * from "./OcrItemListAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports